import React, { useState, useEffect, useRef } from "react";
import Tooltip from "../../common/Tooltip/Tooltip";

interface SiteNameComponentsI {
  tankId: string;
  alarm: boolean;
  tankName: string;
  product: string;
  handleSaveTank: (tankId: any) => void;
  handleOpenTankInNewTab: (tankId: any) => void;
}

const SiteNameComponent: React.FC<SiteNameComponentsI> = ({
  tankId,
  alarm,
  product,
  tankName,
  handleSaveTank,
  handleOpenTankInNewTab,
}) => {
  const [showContextMenu, setShowContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
  } | null>(null);
  const contextMenuRef = useRef<HTMLUListElement | null>(null);

  useEffect(() => {
    const closeMenu = () => setShowContextMenu(null);
    window.addEventListener("close-all-context-menus", closeMenu);
    return () => {
      window.removeEventListener("close-all-context-menus", closeMenu);
    };
  }, []);
  
  const handleContextMenu = (event: React.MouseEvent) => {
    event.preventDefault();
    window.dispatchEvent(new Event("close-all-context-menus"));
    setShowContextMenu(
      showContextMenu == null
        ? { mouseX: event.clientX, mouseY: event.clientY }
        : null
    );
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      contextMenuRef.current &&
      !contextMenuRef.current.contains(event.target as Node)
    ) {
      setShowContextMenu(null);
    }
  };
  const handleContextMenuClick = (tankId: string) => {
    handleOpenTankInNewTab(tankId);
    setShowContextMenu(null);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex justify-between">
      <div className="flex flex-col">
        <Tooltip content={tankName} direction="top">
          <p
            className="text-[14px] font-bold text-primary-400 cursor-pointer  truncate"
            onClick={() => handleSaveTank(tankId)}
            onContextMenu={handleContextMenu}
          >
            {tankName}
          </p>
        </Tooltip>
        {showContextMenu && (
          <ul
            className={` w-{300} absolute transform translate-x-1/2 mt-2 z-50  bg-darkColor-600 shadow-lg list-none p-2 rounded-md  justify-center`}
            ref={contextMenuRef}
          >
            <li
              className=" items-center relative w-96 rounded-[8px] px-1 py-2 cursor-pointer bg-darkcolor-800 text-neutral-25 border-darkcolor-400 border-[1px] origin-top-right absolute  hover:bg-darkcolor-600 hover:text-neutral-25"
              onClick={() => handleContextMenuClick(tankId)}
            >
              Open in new tab
            </li>
          </ul>
        )}
        <p className="text-[14px] text-neutral-25">{product}</p>
      </div>
      <div className="pt-[7px]">
        {alarm && (
          <div className="w-[8px] h-[8px] rounded-[50%] bg-error-500" />
        )}
      </div>
    </div>
  );
};

export default SiteNameComponent;
